var map = {
	"./step-dogrulma.png": 989,
	"./step-kiyam.png": 541,
	"./step-niyet.png": 781,
	"./step-oturus.png": 868,
	"./step-ruku.png": 303,
	"./step-secde.png": 28,
	"./step-selam.png": 59,
	"./step-tahiyyat.png": 265,
	"./step-tekbir.png": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;